module.exports = __webpack_public_path__ + "img/Mail.76a07422.gif";